import { render, staticRenderFns } from "./entry.vue?vue&type=template&id=72231bff&scoped=true"
import script from "./entry.vue?vue&type=script&lang=js"
export * from "./entry.vue?vue&type=script&lang=js"
import style0 from "./entry.vue?vue&type=style&index=0&id=72231bff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72231bff",
  null
  
)

export default component.exports